/* eslint-disable */
import triggerPageGoals from '@/resources/trigger-page-goals.js';

export default {
    methods: {
        triggerPageGoals(dataTrackingString) {
            // this.goalsObj = JSON.parse(this.goals.replace(/'/g, '"'));
            const data = JSON.parse(dataTrackingString.replace(/'/g, '"'));
            const {goalId, ...pageEvent} = data;
            const goalObj = {'goalId': goalId};
            const pageEventObj = pageEvent;

            triggerPageGoals.post('/aha-service/analytics/TriggerGoal', goalObj);
            triggerPageGoals.post('/aha-service/analytics/trackevent', pageEventObj);
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/mixins/page-goals.js